export const SAVE_AUTH_USER = 'save_auth_user';
export const UPDATE_EMAIL = 'update_email';
